import { api, clearToken, setToken } from './client.js';

export async function anon() {
  const r = await api.post('/auth/anon', undefined, { auth: false });
  setToken(r.access_token);
  return r;
}

export async function me() {
  return api.get('/auth/me');
}

export async function login(email, password) {
  const r = await api.post('/auth/login', { email, password }, { auth: false });
  setToken(r.access_token);
  return r;
}

export async function register(email, password) {
  return api.post('/auth/register', { email, password }, { auth: false });
}

export async function resendRegistration(email) {
  return api.post('/auth/register/resend', { email }, { auth: false });
}

export async function verifyRegistration(email, code) {
  const r = await api.post('/auth/register/verify', { email, code }, { auth: false });
  setToken(r.access_token);
  return r;
}

export async function linkRequest(email) {
  return api.post('/auth/link', { email });
}

export async function linkVerify(email, code, password) {
  const r = await api.post('/auth/link/verify', { email, code, password });
  setToken(r.access_token);
  return r;
}

export function logout() {
  clearToken();
}
